import { Button, Container } from "@mui/material";
import Table from "components/Table2";
import AddIcon from "assets/icons/AddIcon";
import usePayrollData from "./data";
import SpecificationsForm from "./SpecificationsForm";
import { useState } from "react";

export default function Payroll() {
    const payrollData = usePayrollData();
    const { handleChange, handleDelete, handleAddRow, handleSpecs, handleSubmit } = payrollData;
    const { data, count, preferences } = payrollData;
    const [state, setState] = useState<any>({
        pagination: {
            page: 1,
            perPage: 5,
        },
    });

    return (
        <Container maxWidth="lg">
            {/* <div className="bg-gray-500 flex h-14 place-content-center text-white text-2xl place-items-center">
                <p>فیش حقوقی</p>
            </div>
            <div className="flex justify-end mt-5">
                <div className="flex gap-4">
                    <span className="font-bold">تاریخ</span>
                    <span>
                        1403/12/12
                    </span>
                </div>
            </div>
            <div className="flex gap-5 justify-between mt-5">
                <div className="flex gap-4">
                    <span className="font-bold">کد کارمند</span>
                    <span>2</span>
                </div>
                <div className="flex gap-4">
                    <span className="font-bold">نام و نام خانوادگی</span>
                    <span>محمدرضا محمدی</span>
                </div>
                <div className="flex gap-4">
                    <span className="font-bold">شماره ملی</span>
                    <span>0025656465</span>
                </div>

            </div>
            <table className="w-full text-sm rtl:text-right text-right border mt-5">
                <thead>
                    <tr>
                        <td className="border-l font-bold">
                            کارکرد ماهانه
                        </td>
                        <td className="border-l font-bold">
                            حقوق و  دستمزد (ریال)
                        </td>
                        <td className="font-bold">
                            کسورات (ریال)
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr></tr>
                </tbody>

            </table> */}
            <div>
                <div style={{display: "flex", justifyContent: "space-between", margin: "20px 0px"}}>
                    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                        <span style={{fontSize: "18px", color: "#1a1919"}}>سند حقوق</span>
                        <span style={{fontSize: "10px", color: "#aeaeae"}}>ثبت اسناد حقوق کسب و کار</span>
                    </div>
                    <div>
                        <Button variant="contained" onClick={handleSubmit}>
                            ذخیره اطلاعات
                        </Button>
                    </div>
                </div>
                <SpecificationsForm data={data.specs} onChange={handleSpecs}/>
                <div>
                    <div
                        style={{
                            position: "relative",
                            overflow: "auto",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <Table
                            key={count}
                            cols={data.cols}
                            headers={data.headers}
                            rows={data.rows}
                            onChange={handleChange}
                            onDelete={handleDelete}
                            preferences={preferences}
                            pagination={{
                                ...state.pagination,
                                onChange: ({page, perPage}) =>
                                    setState((x: any) => ({...x, pagination: {...x.pagination, page, perPage}})),
                            }}
                        />
                    </div>
                    <Button style={{margin: "20px 0px", gap: "10px"}} onClick={handleAddRow}>
                        <AddIcon/>
                        <span>افزودن ردیف</span>
                    </Button>
                </div>
            </div>
        </Container>
    );
}
